<!-- gmail-mobile-02 preview — Gmail inbox, ad row with a landscape thumbnail -->
<app-mobile-frame>
  <div frameTop class="gm-inbox-topbar">
    <div class="gm-inbox-searchbar d-flex flex-row align-items-center justify-content-between">
      <i class="bi bi-list gm-inbox-icon"></i>
      <span class="gm-inbox-avatar placeholder"></span>
    </div>
  </div>

  <div class="gm-inbox">
    <div class="gm-inbox-tabs">
      <span class="gm-inbox-tab-bar placeholder"></span>
    </div>

    <!-- START: Real ad -->
    <a class="gm-inbox-ad d-flex flex-row text-decoration-none" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <img *ngIf="creativeImage; else noThumb" class="gm-inbox-logo" [src]="creativeImage" alt="" />
      <ng-template #noThumb><span class="gm-inbox-logo"></span></ng-template>

      <div class="gm-inbox-copy">
        <div class="gm-inbox-line1">
          <span class="gm-inbox-sponsored">Ad</span> · <span class="gm-inbox-sender">Valamar</span>
          <i class="bi bi-box-arrow-up-right gm-inbox-sponsored gm-inbox-external"></i>
        </div>
        <span class="gm-inbox-headline">{{ data.headlines[0] || "Your headline appears here" }}</span>
      </div>

      <div class="gm-inbox-actions">
        <i class="bi bi-three-dots-vertical"></i>
      </div>
    </a>
    <!-- END: Real ad -->

    <div class="gm-inbox-row d-flex flex-row" *ngFor="let row of inboxSkeletonRows">
      <span class="gm-inbox-row-avatar placeholder"></span>
      <div class="gm-inbox-row-lines d-flex flex-column">
        <span class="gm-inbox-row-bar gm-inbox-row-bar-short placeholder"></span>
        <span class="gm-inbox-row-bar gm-inbox-row-bar-mid placeholder"></span>
        <span class="gm-inbox-row-bar placeholder"></span>
      </div>
    </div>
  </div>

  <div frameBottom class="gm-inbox-bottomnav d-flex flex-row justify-content-around align-items-center">
    <span class="gm-inbox-bottomnav-btn"><i class="bi bi-envelope"></i></span>
    <i class="bi bi-chat-square"></i>
    <i class="bi bi-camera-video"></i>
  </div>
</app-mobile-frame>
